import { t, fmtHours } from "@/lib/i18n";
import { Clock, MapPin, Navigation, Bot } from "lucide-react";
import { CATEGORIES, MODALITY, mapsLink, formatKm } from "@/lib/categories";

export const OfficePopup = ({ office, onAskAI }) => {
  const cat = CATEGORIES[office.category];
  const mod = MODALITY[office.modality] || MODALITY.presencial;
  return (
    <div data-testid={`map-popup-${office.id}`} className="w-64 font-body">
      <span
        className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-white"
        style={{ background: cat.color }}
      >
        {cat.label}
      </span>
      <h3 className="mt-2 font-display text-[15px] font-bold leading-snug text-ac-ink">{office.name}</h3>
      <p className="mt-2 flex gap-2 text-xs text-ac-muted">
        <MapPin className="h-3.5 w-3.5 shrink-0" /> {office.address || t("osm.noAddr")}
        {office.municipality ? `, ${office.municipality}` : ""}
      </p>
      <p className="mt-1 flex gap-2 text-xs text-ac-muted">
        <Clock className="h-3.5 w-3.5 shrink-0" /> {fmtHours(office.hours)}
      </p>
      <div className="mt-2 flex items-center gap-2">
        <span className={`rounded-full border px-2 py-0.5 text-[10px] font-medium ${mod.tone}`}>{mod.label}</span>
        {office.distance_km != null && <span className="text-[11px] text-ac-muted">{t("popup.away", { d: formatKm(office.distance_km) })}</span>}
      </div>
      <div className="mt-3 grid gap-2">
        <button
          data-testid={`popup-ask-ai-${office.id}`}
          onClick={() => onAskAI(office)}
          className="flex items-center justify-center gap-2 rounded-lg bg-ac-primary px-3 py-2 text-xs font-semibold text-white transition-colors hover:bg-ac-primary-hover"
        >
          <Bot className="h-4 w-4" /> {t("popup.ask")}
        </button>
        <a
          data-testid={`popup-directions-${office.id}`}
          href={mapsLink(office)}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 rounded-lg border border-ac-line px-3 py-2 text-xs font-semibold !text-ac-ink transition-colors hover:bg-ac-surface2"
        >
          <Navigation className="h-4 w-4" /> {t("popup.directions")}
        </a>
      </div>
    </div>
  );
};
